/*
 * These are the variables that determine what our central data store (`../reducers/index.js`)
 * changes in our state.
 */

export const SENDING_REQUEST = 'SENDING_REQUEST';
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export const SSO_LOGIN_REQUEST = 'SSO_LOGIN_REQUEST';
export const VALIDATE_MFA_REQUEST = 'VALIDATE_MFA_REQUEST';
export const LOGOUT = 'LOGOUT';
export const PASSWORD_REQUEST = 'PASSWORD_REQUEST';
export const PASSWORD_RESET_REQUEST = 'PASSWORD_RESET_REQUEST';
export const REQUEST_ERROR = 'REQUEST_ERROR';
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const LOADING = 'LOADING';

export const GET_LOGIN_TEXT = 'GET_LOGIN_TEXT';
export const SET_LOGIN_TEXT = 'SET_LOGIN_TEXT';

export const SET_MFA_CHALLENGE = 'SET_MFA_CHALLENGE';
export const SET_MFA_STATUS = 'SET_MFA_STATUS';
export const GET_MFA_STATUS = 'GET_MFA_STATUS';

export const REQUEST_FORGOT_PW = 'REQUEST_FORGOT_PW';
export const REQUEST_FORGOT_PW_CHANGE = 'REQUEST_FORGOT_PW_CHANGE';
